<template lang="pug">
	div(:class="{'edit-inline': !wrapped, 'edit-mode':editModeActive}")
		span.quick-edit__value(v-if="!notext && !r['_edit_'+field]") {{ r[field] }}
		input.form-control.form-control-sm(type="text", v-model="r['_'+field]", v-if="r['_edit_' + field]")
		span.quickedit-buttons
			a(href="javascript:void(0)", @click="editRecord(r, field)", v-if="!r['_edit_' + field]")
				i.la.la-pencil
			a(href="javascript:void(0)", @click="cancelEditRecord(r, field)", v-if="r['_edit_' + field]")
				i.la.la-times
			a(href="javascript:void(0)", @click="saveRecord(r, field)", v-if="r['_edit_' + field]")
				i.la.la-save
</template>

<script>
export default {
	name: "QuickEdit",
	props: {
		notext: { type: Boolean, default: false },
		wrapped: Boolean,
		r: { type: Object },
		field: { type: String },
	},
	emits: ["on-save"],
	data() {
		return { editMode: false };
	},
	computed: {
		editModeActive() {
			return this.editMode;
		},
	},
	methods: {
		editRecord(r, field) {
			this.editMode = true;
			r["_" + field] = r[field];
			r["_edit_" + field] = true;
		},
		cancelEditRecord(r, field) {
			this.editMode = false;
			r["_edit_" + field] = false;
		},
		async saveRecord(r, field) {
			this.$emit("on-save", r, field);
		},
	},
};
</script>
